import { useState } from 'react';
import { toast } from 'react-toastify';

import { BasicModal, Button } from '../../Shared';
import styles from './LicenseModal.module.css';

const MODAL_WIDTH = '100%';
const MODAL_HEIGHT = '280px';
const LICENSE_AGREEMENT_URL = '/assets/license_agreement_v.3.0.0.html';

export const LicenseModal = ({ open, credentials, onSignIn, onClose }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    setIsSubmitting(true);

    try {
      const response = await fetch('/accept-license-agreement', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(credentials),
      });

      if (response.status !== 200) throw new Error();

      setIsSubmitting(false);
      onClose();
      onSignIn();
    } catch {
      setIsSubmitting(false);
      toast.error('Something went wrong, please try again!', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  };

  return (
    <BasicModal open={open} onClose={isSubmitting ? undefined : onClose}>
      <div className={styles.licenseModal}>
        <h2 className={styles.modalTitle}>
          ProspectIQ.ai Software-as-a-Service (SaaS) Agreement – terms &
          conditions
        </h2>
        <div className={styles.modalBody}>
          <iframe
            src={LICENSE_AGREEMENT_URL}
            width={MODAL_WIDTH}
            height={MODAL_HEIGHT}
            style={{ border: 'none' }}
            title="License Agreement"
          />
        </div>
        <div className={styles.modalFooter}>
          <Button title="I Agree" onClick={onSubmit} disabled={isSubmitting} />
          <Button
            title="Cancel"
            variant="text"
            onClick={onClose}
            disabled={isSubmitting}
          />
        </div>
      </div>
    </BasicModal>
  );
};
